import { StoreListingApi } from '../../generated/api';
import configuration from './configuration';

export const storeListingApi = new StoreListingApi(configuration);
